import { forwardRef, useId } from 'react';

function LabelledControl({label, id, children}) {
  return label ? <div className="fc-field"><label className="fc-label" htmlFor={id}>{label}</label>{children}</div> : children;
}

/** Native controls for existing labelled forms. Callers retain values, validation and submission. */
export const Input = forwardRef(function Input({ className = '', type = 'text', label, id, ...props }, ref) {
  const generated = useId();
  const controlId = id || (label ? `fc-input-${generated}` : undefined);
  const concealed = type === 'hidden' || /(?:^|\s)(?:hidden|sr-only)(?:\s|$)/.test(className);
  const role = concealed ? '' : ['checkbox', 'radio'].includes(type) ? 'fc-choice-control' : type === 'file' ? 'fc-file-control' : 'fc-control';
  return <LabelledControl label={label} id={controlId}><input {...props} id={controlId} ref={ref} type={type} className={`${role} ${className}`} /></LabelledControl>;
});
export const Select = forwardRef(function Select({ className = '', label, id, children, ...props }, ref) {
  const generated = useId();
  const controlId = id || (label ? `fc-select-${generated}` : undefined);
  return <LabelledControl label={label} id={controlId}><select {...props} id={controlId} ref={ref} className={`fc-control ${className}`}>{children}</select></LabelledControl>;
});
export const Textarea = forwardRef(function Textarea({ className = '', label, id, ...props }, ref) {
  const generated = useId();
  const controlId = id || (label ? `fc-textarea-${generated}` : undefined);
  return <LabelledControl label={label} id={controlId}><textarea {...props} id={controlId} ref={ref} className={`fc-control fc-textarea ${className}`} /></LabelledControl>;
});

/** Inline label and select with an optional wrapping secondary action. */
export function EntrySelector({label='Entry:', action, className='', id, readOnlyValue, ...props}) {
  const generated=useId();
  const controlId=id || `fc-entry-${generated}`;
  return <div className={`fc-inline-select ${className}`}>
    {readOnlyValue === undefined ? <label className="fc-inline-select__label" htmlFor={controlId}>{label}</label> : <span className="fc-inline-select__label">{label}</span>}
    {readOnlyValue === undefined ? <Select {...props} id={controlId}/> : <span>{readOnlyValue}</span>}
    {action}
  </div>;
}
